var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/EstimationRenderer/EstimationRenderer.tsx";
import { ListItemIcon, ListItemText, ListItem } from '@mui/material';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { CalculateIcon, Tooltip } from '@gmini/ui-kit';
import { ItemTooltip } from "../../../SelectDependencies/ItemTooltip";
import { useCtxData } from "../itemPropsCtx";
import { useExplorerItemStyles } from "../../../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EstimationRenderer = function EstimationRenderer(_ref) {
  var item = _ref.item,
      onSelect = _ref.onSelect,
      selected = _ref.selected;
  var node = item.payload;

  var _useCtxData = useCtxData(),
      onClickNode = _useCtxData.onClickNode,
      currentClassifierData = _useCtxData.currentClassifierData;

  var itemListStyles = useExplorerItemStyles();
  var isCurrentUserClassifier = node.classifierId === (currentClassifierData === null || currentClassifierData === void 0 ? void 0 : currentClassifierData.id);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: isCurrentUserClassifier ? 'Нельзя создавать циклические зависимости' : '',
    children: /*#__PURE__*/_jsxs(ListItem, {
      dense: true,
      button: true,
      onClick: function onClick() {
        onSelect();
        onClickNode(node);
      },
      classes: itemListStyles,
      selected: selected,
      disabled: isCurrentUserClassifier,
      children: [node.type === 'EstimationNode' && /*#__PURE__*/_jsx(ListItemIcon, {
        children: /*#__PURE__*/_jsx(CalculateIcon, {
          width: 18,
          height: 18
        })
      }), /*#__PURE__*/_jsx(ListItemText, {
        disableTypography: true,
        children: /*#__PURE__*/_jsx(ItemTooltip, {
          title: node.title,
          children: /*#__PURE__*/_jsx(Typography, {
            noWrap: true,
            variant: "body2",
            children: node.title
          })
        })
      })]
    })
  });
};